import * as React from 'react';
import { Children, type ReactNode } from 'react'

import { useGlobalControls } from '../GlobalControlsProvider.js'
import { useTidalStories } from '../TidalStoriesProvider.js'

import { ResizablePanel } from './ResizablePanel.js'
import { Tools } from './Tools.js'
import type { ToolsProps } from './types.js'

export function GlobalToolbar(props: ToolsProps) {
  const { children, placement } = props

  const { globalControlsDisabled, globalControlsConfig } = useTidalStories()
  const config = globalControlsConfig[placement]

  const { controls } = useGlobalControls()
  const controlsToPlace = controls[placement] as ReactNode

  const tabsCount = Children.count(children) + Children.count(controlsToPlace)

  if (globalControlsDisabled || tabsCount === 0 || config?.hide) {
    return null
  }

  return (
    <ResizablePanel
      placement={placement}
      disabled={config?.disableResize}
      initialSize={config?.initialSize}
      minSize={config?.minSize}
    >
      <Tools placement={placement}>
        {children as any}
        {controlsToPlace}
      </Tools>
    </ResizablePanel>
  )
}
